import { map } from 'rxjs';
import { ComponentDataSourceService } from '../../component-data-source.service';
import { UserService } from '../../../../services/user/user.service';
import { Injector } from '@angular/core';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { EducationalPathItemDTO } from '../../../../dto/educational-path/educational-path-item.dto';
import { EducationalPathUserDTO } from '../../../../dto/educational-path/educational-path-user.dto';

interface CompletedPathDTO {
    name: string | null;
    participated_items: string;
    maintenance_started_at: Date | null;
    certification_url: string | undefined;
}

export function profile_paths_completed(componentDataSourceService: ComponentDataSourceService & { injector: Injector }) {
    const userService = componentDataSourceService.injector.get(UserService);

    return {
        name: 'Gennemførte forløb',
        description: 'Liste over alle gennemførte uddannelser og vedligeholdelse',
        execute: (params?: LoadDataParams) => {
            return userService.getEducationalPaths().pipe(
                map((paths: EducationalPathUserDTO[]) => {
                    const completedPaths = paths
                        .filter(path => {
                            // Calculate completion status from progress data since we removed the status field
                            return path.progress_percentage === 100 && path.completed_items === path.total_items;
                        })
                        .map((path): CompletedPathDTO => ({
                            name: path.name,
                            participated_items: [...path.requirements, ...path.maintenance]
                                .filter(item => item.completed)
                                .map(item => item.name)
                                .join(', '),
                            maintenance_started_at: path.maintenance_started_at ? new Date(path.maintenance_started_at) : null,
                            certification_url: path.certification_url
                        }));

                    // Handle pagination if params are provided
                    if (params?.queryParams) {
                        const pageSize = Number(params.queryParams['pageSize']) || 10;
                        const pageIndex = Number(params.queryParams['pageIndex']) || 0;
                        const start = pageIndex * pageSize;
                        const end = start + pageSize;
                        
                        return {
                            items: completedPaths.slice(start, end),
                            totalCount: completedPaths.length,
                            pageSize,
                            pageIndex
                        };
                    }

                    return {
                        items: completedPaths,
                        totalCount: completedPaths.length,
                        pageSize: completedPaths.length,
                        pageIndex: 0
                    };
                })
            );
        },
        settings: {
            columns: [
                { key: 'name', header: 'Navn', type: 'text' },
                { key: 'participated_items', header: 'Gennemførte elementer', type: 'text' },
                { key: 'completed_at', header: 'Gennemført', type: 'date' },
                {
                    key: 'certification_url',
                    header: '',
                    type: 'button',
                    buttonText: 'Hent certifikat',
                    buttonColor: 'primary',
                    variant: 'raised',
                    alignment: 'right',
                    showIf: (row: any) => !!row.certification_url,
                    action: (row: any) => {
                        if (row.certification_url) {
                            window.open(row.certification_url, '_blank');
                        }
                    }
                }
            ],
            pageable: true,
            sortable: true,
            searchable: true,
            rowHover: true,
            defaultSortColumn: 'completed_at',
            defaultSortDirection: 'desc'
        }
    };
} 